// Azure component tags
export const PERMA_TAG_PORTFOLIO = 'PermaTagProductPortfolio';
export const PERMA_TAG_DEPLOYMENTGROUP = 'PermaTagDeploymentGroup';
export const PERMA_TAG_ENVIRONMENT = 'PermaTagEnvironment';
export const PERMA_TAG_REGION = 'PermaTagRegion';
export const PERMA_TAG_REPO = 'PermaTagGitRepo';
export const AZURE_TAG_GIT_TAG_OR_BRANCH = 'GitTagOrBranch';

// Deployment groups
export const DEPLOYMENT_GROUP_SHOPWEBAPPS = 'shop-web-apps';
export const DEPLOYMENT_GROUP_PRIMARYWEBAPPS = 'primary-web-apps';

// Ordered list of deployment groups. The order is intentional — the
// VersionChecker dropdown sorts by this sequence so the UI feels
// consistent. (The release-checklist BDirect table now groups by Confluence
// section instead, so deployment groups don't drive its layout.)
export const DEPLOYMENT_GROUPS: string[] = [
  'databases',
  DEPLOYMENT_GROUP_PRIMARYWEBAPPS,
  'shop-apis',
  DEPLOYMENT_GROUP_SHOPWEBAPPS,
  'other-apis',
  'other-web-apps',
  'function-apps',
  'data-factories',
];

// custom name: code repository name
// Used to assign a deployment group to components that aren't deployed to
// Azure (so the Azure tag-based lookup misses them) — e.g. MFEs published as
// static content, or database repos that only produce migration artefacts.
// The inner value is the **Bitbucket repo name** (matches the path segment
// inside the component's `backstage.io/source-location` annotation), not the
// Backstage component name.
export const customComponentMap: Record<string, Record<string, string>> = {
  [DEPLOYMENT_GROUP_PRIMARYWEBAPPS]: {
    'bdirect-mfe-js': 'bdirect-micro-frontend',
  },
  databases: {
    bidvestdirect: 'bidvestdirect',
    'menuplanning-database': 'menuplanning_database',
    'opri-database': 'opri_database',
  },
};
